import Vue from "vue";
import Auth from "../fc/Auth/Auth";

Vue.prototype.$auth = Auth;
Vue.config.errorHandler = (error, context) => {
  console.trace(error);
};
